<p>Please select additional prep locations to apply changes to:</p>
Prep Locations Selected: {{ prepLocationsSelected }}
<div class="scroll-list">
  <mat-checkbox [(ngModel)]="selectAll" (change)="selectAllPrepLocations()" class="checkbox">
    Select All Prep Locations
  </mat-checkbox>
  @for (prepLoc of prepLocations; track prepLoc) {
    <mat-checkbox
      [(ngModel)]="prepLoc.isSelected"
      [disabled]="prepLoc.prepLocationName === currentPrepLocation"
      [id]="prepLoc.prepLocationName"
      (change)="refreshPrepLocationsSelected()">
      {{ prepLoc.prepLocationName }}
    </mat-checkbox>
  }
</div>
